const DO_NOT_TRACK_ADVERTISING_PROPERTY_KEY = 'dnt_a'

function checkIfAdvertisingTrackingAllowed() {
  if (typeof window === 'undefined') return

  const value = window.localStorage.getItem(DO_NOT_TRACK_ADVERTISING_PROPERTY_KEY)

  return value === '0'
}

export default checkIfAdvertisingTrackingAllowed
